import { INSPECAO_MT_BT_TIPO_SERVICO_ID } from '../../../utils';
import {
  ACESSO_VEICULO_NSMP,
  ACESSOS_NSMP,
  EQUIPES_NSMP,
  PRIORIDADES_NSMP,
} from '../../../constants/nsmpUtils';

export const QUERY_PROCEDIMENTO_ID = 'procedimentoId';
export const PROCEDIMENTO_NOVO = 'novo';

export const INSPECAO_MT_BT_ID = INSPECAO_MT_BT_TIPO_SERVICO_ID;

/** Saída genérica do inspetor: não entra como gatilho de procedimento. */
export const SERVICO_OUTROS_ID = '36b5770f-e8ba-42ca-a743-ea39c0a861ea';

export const CATEGORIAS_NSMP = [
  { value: 'E', label: 'E-mail' },
  { value: 'EM', label: 'Emergência' },
  { value: 'L', label: 'Limpeza de Faixa' },
  { value: 'M', label: 'Manutenção' },
  { value: 'NC', label: 'Não Cadastrado' },
  { value: 'OB', label: 'Objeto na Rede' },
  { value: 'OS', label: 'OSAF' },
  { value: 'PL', label: 'Planilha' },
  { value: 'P', label: 'Poda RDR ou RDU' },
  { value: 'PR', label: 'Programada' },
  { value: 'FO', label: 'Fibra Óptica' },
  { value: 'RT', label: 'Relatório Termográfico' },
  { value: 'AT', label: 'Análise Termográfico' },
];

export const PRIORIDADES = [
  { id: 'ALTA', nome: 'Alta' },
  { id: 'MEDIA', nome: 'Média' },
  { id: 'BAIXA', nome: 'Baixa' },
];

export const PRIORIDADE_AJUDA = 'Ordem de importância do card na digitação. Alta aparece primeiro, depois Média e, por último, Baixa.';

/**
 * Exemplo do dialog "Ver exemplo": um procedimento com região, serviço e prioridade da NSMP,
 * conferido contra quatro NSMP. `valor` é o que se compara; `exibe`, como aparece no cadastro.
 */
export const EXEMPLO_REGRA = {
  criterios: [
    { chave: 'regiao', coluna: 'Região', campo: 'Malhas', valor: 'Malha Leste', exibe: 'Malha Leste', motivo: 'outra região' },
    { chave: 'servico', coluna: 'Serviço', campo: 'Serviços', valor: 'Substituir Cruzeta Podre', exibe: 'Substituir Cruzeta Podre', motivo: 'outro serviço' },
    { chave: 'prioridade', coluna: 'Prioridade', campo: 'Prioridade da NSMP', valor: 'E', exibe: 'E - Emergência', motivo: 'outra prioridade' },
  ],
  nsmps: [
    { nome: 'NSMP 1', regiao: 'Malha Leste', servico: 'Substituir Cruzeta Podre', prioridade: 'E' },
    { nome: 'NSMP 2', regiao: 'Malha Leste', servico: 'Substituir Cruzeta Podre', prioridade: '2' },
    { nome: 'NSMP 3', regiao: 'Malha Centro', servico: 'Substituir Cruzeta Podre', prioridade: 'E' },
    { nome: 'NSMP 4', regiao: 'Malha Leste', servico: 'Retirar Vespeiro', prioridade: 'E' },
  ],
};

/** Opções de MultiSelectV2 (`value`/`label`) a partir das listas `{ id, nome }` do cabeçalho da NSMP. */
const emOpcoes = (lista) => lista.map((item) => ({
  value: item.id,
  label: item.descricao ? `${item.nome} - ${item.descricao}` : item.nome,
}));

export const EQUIPES_OPCOES = emOpcoes(EQUIPES_NSMP);
export const PRIORIDADES_NSMP_OPCOES = emOpcoes(PRIORIDADES_NSMP);
export const ACESSOS_OPCOES = emOpcoes(ACESSOS_NSMP);

/** Três estados: sem critério (`''`), sim e não. Não é checkbox. */
export const ACESSO_VEICULO_OPCOES = [{ id: '', nome: 'Indiferente' }, ...ACESSO_VEICULO_NSMP];

export const prioridadeLabel = (valor) =>
  PRIORIDADES.find((item) => item.id === valor)?.nome || valor || '';

export const emptyProcedimento = () => ({
  titulo: '',
  conteudoHtml: '',
  prioridade: 'MEDIA',
  ativo: true,
  desativadoEm: null,
  desativadoPor: '',
  subtipoIds: [],
  malhaIds: [],
  gerenciaIds: [],
  poloIds: [],
  tipoServicoIds: [],
  categorias: [],
  equipes: [],
  prioridadesNsmp: [],
  acessos: [],
  acessoVeiculo: '',
  arquivos: [],
  arquivoIdsRemovidos: [],
});
